import { render, staticRenderFns } from "./CollectingDebtMatchForm.vue?vue&type=template&id=29289f89"
import script from "./CollectingDebtMatchForm.vue?vue&type=script&lang=js"
export * from "./CollectingDebtMatchForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports